// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,body {
	height: 100%;
    background-color: rgb(63, 93, 126);
}

body.my-login-page {
	background-color: #f7f9fb;
	font-size: 14px;
}

.my-login-page .brand {
	width: 180px;
	height: 170px;
	overflow: hidden;
	border-radius: 10px;
	margin: 40px auto;
	position: relative;
	z-index: 1;
}

.my-login-page .brand img {
	width: 100%;
    padding: 10px;
}

.my-login-page .card-wrapper {
	width: 400px;
}

.my-login-page .card {
	border-color: transparent;
	box-shadow: 0 4px 8px rgba(0,0,0,.05);
}

.my-login-page .card.fat {
	padding: 10px;
}

.my-login-page .card .card-title {
	margin-bottom: 30px;
}

.my-login-page .form-control {
	border-width: 2.3px;
}

.my-login-page .form-group label{
	width: 100%;
}

.my-login-page .btn.btn-block {
	padding: 12px 10px;
}

.my-login-page .footer {
	margin: 40px 0;
	color: #888;
	text-align: center;
}

@media screen and (max-width: 425px) {
	.my-login-page .card-wrapper {
		width: 90%;
		margin: 0 auto;
	}
}

@media screen and (max-width: 320px) {
	.my-login-page .card.fat {
		padding: 0;
	}

	.my-login-page .card.fat .card-body {
		padding: 15px;
	}
}

.btnn {
    margin-top: 10px;
}

/* navbar */


/* ============ desktop view ============ */
@media all and (min-width: 992px) {

    .bg-custom {
        background-color: rgb(103, 132, 163);
    }
	.navbar {
    font-size: 14px;
}
	.dropdown-menu li{
		position: relative;
	}
	.dropdown-menu .submenu{ 
		display: none;
		position: absolute;
		left:100%; top:-7px;
	}
	.dropdown-menu .submenu-left{ 
		right:100%; left:auto;
	}

	.dropdown-menu > li:hover{ background-color: #adadad }
	.dropdown-menu > li:hover > .submenu{
		display: block;
	}
}	
/* ============ desktop view .end// ============ */

/* ============ small devices ============ */
@media (max-width: 991px) {

.dropdown-menu .dropdown-menu{
		margin-left:0.7rem; margin-right:0.7rem; margin-bottom: .5rem;
}

}	
/* ============ small devices .end// ============ */

.box-center{
    width: 98%;
    height: 98%;
    padding: 34px;
    margin: 10px auto 0 auto;
    border-radius: 10px;
    border: 1px solid #000000;
    background-color: rgb(103, 132, 163);
  }

.bg-custom {
    color: rgb(255, 255, 255);
}

.transparent-input {
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(0, 0, 0); /* Adicione uma borda para tornar o campo visível */
    color: #000000; /* Adicione uma cor de texto para melhor legibilidade */
  }

.form-label{
    color: #ffffff;
	font-size: 14px;
}

.form-label1{
    color: #ffffff;
	font-size: 60px;
}

.hfx3{
    color: #000000;
	font-size: 20px;
}

.form-label3{
    color: #ffffff;
	font-size: 20px;
}

.hfx{
    color: #ffffff;
	font-size: 17px;
}
.hfx4{
    color: #ffffff;
	font-size: 14px;
}

.hfx3{
    color: #000000;
	font-size: 17px;
}

.hfx2{
    color: #ffffff;
	font-size: 24px;
}

/* Adicione essas classes ao seu arquivo de estilo CSS */
.frases-superior-container {
  border: 1px solid black;
  background-color: lightgray; /* Cor de fundo desejada */
  padding: 10px; /* Ajuste o preenchimento conforme necessário */
  border-radius: 5px; /* Adicione bordas arredondadas conforme desejado */
  height: 610px;
}

.frase-superior {
  margin-bottom: 8px; /* Espaçamento entre as frases superiores */
}

.total-row {
	background-color: lightgray; /* Cor de fundo da linha de totais */
  }
  
  /* Estilo para ocultar os botões na linha de totais */
  .total-row .btn {
	display: none;
  }`, "",{"version":3,"sources":["webpack://./src/style/style.css"],"names":[],"mappings":"AAAA;CACC,YAAY;IACT,kCAAkC;AACtC;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;IACR,aAAa;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,qCAAqC;AACtC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC;EACC,UAAU;EACV,cAAc;CACf;AACD;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;IACI,gBAAgB;AACpB;;AAEA,WAAW;;;AAGX,2CAA2C;AAC3C;;IAEI;QACI,oCAAoC;IACxC;CACH;IACG,eAAe;AACnB;CACC;EACC,kBAAkB;CACnB;CACA;EACC,aAAa;EACb,kBAAkB;EAClB,SAAS,EAAE,QAAQ;CACpB;CACA;EACC,UAAU,EAAE,SAAS;CACtB;;CAEA,2BAA2B,0BAA0B;CACrD;EACC,cAAc;CACf;AACD;AACA,kDAAkD;;AAElD,4CAA4C;AAC5C;;AAEA;EACE,kBAAkB,EAAE,mBAAmB,EAAE,oBAAoB;AAC/D;;AAEA;AACA,mDAAmD;;AAEnD;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;EACtC;;AAEF;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B,EAAE,mDAAmD;IACnF,cAAc,EAAE,uDAAuD;EACzE;;AAEF;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA;IACI,cAAc;CACjB,eAAe;AAChB;AACA;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA;IACI,cAAc;CACjB,eAAe;AAChB;;AAEA,wDAAwD;AACxD;EACE,uBAAuB;EACvB,2BAA2B,EAAE,0BAA0B;EACvD,aAAa,EAAE,+CAA+C;EAC9D,kBAAkB,EAAE,mDAAmD;EACvE,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,2CAA2C;AACjE;;AAEA;CACC,2BAA2B,EAAE,oCAAoC;EAChE;;EAEA,qDAAqD;EACrD;CACD,aAAa;EACZ","sourcesContent":["html,body {\n\theight: 100%;\n    background-color: rgb(63, 93, 126);\n}\n\nbody.my-login-page {\n\tbackground-color: #f7f9fb;\n\tfont-size: 14px;\n}\n\n.my-login-page .brand {\n\twidth: 180px;\n\theight: 170px;\n\toverflow: hidden;\n\tborder-radius: 10px;\n\tmargin: 40px auto;\n\tposition: relative;\n\tz-index: 1;\n}\n\n.my-login-page .brand img {\n\twidth: 100%;\n    padding: 10px;\n}\n\n.my-login-page .card-wrapper {\n\twidth: 400px;\n}\n\n.my-login-page .card {\n\tborder-color: transparent;\n\tbox-shadow: 0 4px 8px rgba(0,0,0,.05);\n}\n\n.my-login-page .card.fat {\n\tpadding: 10px;\n}\n\n.my-login-page .card .card-title {\n\tmargin-bottom: 30px;\n}\n\n.my-login-page .form-control {\n\tborder-width: 2.3px;\n}\n\n.my-login-page .form-group label{\n\twidth: 100%;\n}\n\n.my-login-page .btn.btn-block {\n\tpadding: 12px 10px;\n}\n\n.my-login-page .footer {\n\tmargin: 40px 0;\n\tcolor: #888;\n\ttext-align: center;\n}\n\n@media screen and (max-width: 425px) {\n\t.my-login-page .card-wrapper {\n\t\twidth: 90%;\n\t\tmargin: 0 auto;\n\t}\n}\n\n@media screen and (max-width: 320px) {\n\t.my-login-page .card.fat {\n\t\tpadding: 0;\n\t}\n\n\t.my-login-page .card.fat .card-body {\n\t\tpadding: 15px;\n\t}\n}\n\n.btnn {\n    margin-top: 10px;\n}\n\n/* navbar */\n\n\n/* ============ desktop view ============ */\n@media all and (min-width: 992px) {\n\n    .bg-custom {\n        background-color: rgb(103, 132, 163);\n    }\n\t.navbar {\n    font-size: 14px;\n}\n\t.dropdown-menu li{\n\t\tposition: relative;\n\t}\n\t.dropdown-menu .submenu{ \n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft:100%; top:-7px;\n\t}\n\t.dropdown-menu .submenu-left{ \n\t\tright:100%; left:auto;\n\t}\n\n\t.dropdown-menu > li:hover{ background-color: #adadad }\n\t.dropdown-menu > li:hover > .submenu{\n\t\tdisplay: block;\n\t}\n}\t\n/* ============ desktop view .end// ============ */\n\n/* ============ small devices ============ */\n@media (max-width: 991px) {\n\n.dropdown-menu .dropdown-menu{\n\t\tmargin-left:0.7rem; margin-right:0.7rem; margin-bottom: .5rem;\n}\n\n}\t\n/* ============ small devices .end// ============ */\n\n.box-center{\n    width: 98%;\n    height: 98%;\n    padding: 34px;\n    margin: 10px auto 0 auto;\n    border-radius: 10px;\n    border: 1px solid #000000;\n    background-color: rgb(103, 132, 163);\n  }\n\n.bg-custom {\n    color: rgb(255, 255, 255);\n}\n\n.transparent-input {\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(0, 0, 0); /* Adicione uma borda para tornar o campo visível */\n    color: #000000; /* Adicione uma cor de texto para melhor legibilidade */\n  }\n\n.form-label{\n    color: #ffffff;\n\tfont-size: 14px;\n}\n\n.form-label1{\n    color: #ffffff;\n\tfont-size: 60px;\n}\n\n.hfx3{\n    color: #000000;\n\tfont-size: 20px;\n}\n\n.form-label3{\n    color: #ffffff;\n\tfont-size: 20px;\n}\n\n.hfx{\n    color: #ffffff;\n\tfont-size: 17px;\n}\n.hfx4{\n    color: #ffffff;\n\tfont-size: 14px;\n}\n\n.hfx3{\n    color: #000000;\n\tfont-size: 17px;\n}\n\n.hfx2{\n    color: #ffffff;\n\tfont-size: 24px;\n}\n\n/* Adicione essas classes ao seu arquivo de estilo CSS */\n.frases-superior-container {\n  border: 1px solid black;\n  background-color: lightgray; /* Cor de fundo desejada */\n  padding: 10px; /* Ajuste o preenchimento conforme necessário */\n  border-radius: 5px; /* Adicione bordas arredondadas conforme desejado */\n  height: 610px;\n}\n\n.frase-superior {\n  margin-bottom: 8px; /* Espaçamento entre as frases superiores */\n}\n\n.total-row {\n\tbackground-color: lightgray; /* Cor de fundo da linha de totais */\n  }\n  \n  /* Estilo para ocultar os botões na linha de totais */\n  .total-row .btn {\n\tdisplay: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
